import { useEffect, useState } from "react"

// L'offre flash -50 % "expire à minuit" est gérée côté front uniquement.
// Valable jusqu'à minuit du jour où l'utilisateur a posé le pied dans le
// funnel pour la première fois (timestamp en sessionStorage). Si l'utilisateur
// revient le lendemain ou refresh après minuit, l'offre n'est plus active —
// l'admin doit la recréer manuellement.
const STORAGE_KEY = "brevet_funnel_promo_start"

let cachedFirstVisitMs = null

const endOfDayMs = (msTimestamp) => {
    const d = new Date(msTimestamp)
    d.setHours(23, 59, 59, 999)
    return d.getTime()
}

const getOrInitFirstVisitMs = () => {
    if (cachedFirstVisitMs != null) return cachedFirstVisitMs
    if (typeof window === "undefined") {
        cachedFirstVisitMs = Date.now()
        return cachedFirstVisitMs
    }
    try {
        const stored = window.sessionStorage?.getItem(STORAGE_KEY)
        const parsed = stored ? parseInt(stored, 10) : NaN
        if (Number.isFinite(parsed) && parsed > 0) {
            cachedFirstVisitMs = parsed
            return parsed
        }
        const now = Date.now()
        window.sessionStorage?.setItem(STORAGE_KEY, String(now))
        cachedFirstVisitMs = now
        return now
    } catch {
        cachedFirstVisitMs = Date.now()
        return cachedFirstVisitMs
    }
}

const computeActive = () => Date.now() < endOfDayMs(getOrInitFirstVisitMs())

export const useMidnightOfferActive = () => {
    const [active, setActive] = useState(computeActive)

    useEffect(() => {
        if (!active) return
        const msUntilEnd = endOfDayMs(getOrInitFirstVisitMs()) - Date.now()
        if (msUntilEnd <= 0) {
            setActive(false)
            return
        }
        const id = setTimeout(() => setActive(false), msUntilEnd)
        return () => clearTimeout(id)
    }, [active])

    return active
}
